export function buildTreatmentsSelectPanelList(
  catalog: any[] | null | undefined,
  searchTerm: string | null | undefined,
  selectedIds: any[] | null | undefined
): any[] {
  const master = catalog ?? [];
  if (!master.length) {
    return [];
  }

  const rawSelected = (selectedIds ?? []).filter(
    (id) => id != null && id !== ''
  ) as any[];
  const selectedIdSet = new Set(rawSelected.map((id) => String(id)));

  const byMasterId = new Map(
    master
      .filter((t: any) => t?.id != null && t.id !== '')
      .map((t: any) => [String(t.id), t])
  );

  const selectedRows: any[] = [];
  for (const id of rawSelected) {
    const row = byMasterId.get(String(id));
    if (row) {
      selectedRows.push(row);
    }
  }

  const term = (searchTerm ?? '').toString().trim().toLowerCase();
  const nameMatch = (t: any) =>
    (t.name ?? '').toString().toLowerCase().includes(term);

  if (term) {
    const everyCatalogItemSelected = master.every((t: any) =>
      selectedIdSet.has(String(t.id))
    );
    // When nothing is left unselected, "selected + matching unselected" stays the full list
    // and search seems broken. Narrow to name matches while every row is selected.
    if (everyCatalogItemSelected) {
      return selectedRows.filter(nameMatch);
    }

    const unselectedMatching = master.filter(
      (t: any) => !selectedIdSet.has(String(t.id)) && nameMatch(t)
    );
    return [...selectedRows, ...unselectedMatching];
  }

  const rest = master.filter((t: any) => !selectedIdSet.has(String(t.id)));
  return [...selectedRows, ...rest];
}
